
import React from 'react';
import ResourceCard from './ResourceCard';
import TranslatedText from '@/TranslatedText';

const AdditionalResources = () => {
  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-6 text-center">
        <TranslatedText text="Additional Resources" />
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <ResourceCard 
          title={<TranslatedText text="Knowledge Base" />}
          description={<TranslatedText text="Browse our extensive knowledge base for detailed articles and tutorials." />}
          buttonText={<TranslatedText text="Explore Knowledge Base" />}
        />
        <ResourceCard 
          title={<TranslatedText text="Community Forum" />}
          description={<TranslatedText text="Connect with other users, share experiences, and find community-driven solutions." />}
          buttonText={<TranslatedText text="Join the Community" />}
        />
        <ResourceCard 
          title={<TranslatedText text="Video Tutorials" />}
          description={<TranslatedText text="Watch step-by-step video guides on how to use our platform effectively." />}
          buttonText={<TranslatedText text="Watch Tutorials" />}
        />
      </div>
    </div>
  );
};

export default AdditionalResources;
